namespace TabAurous.Master {
    export interface EmployeeMasterForm {
        EmployeeCode: Serenity.StringEditor;
        EmployeeName: Serenity.StringEditor;
        EmploymentType: Serenity.ServiceLookupEditor;
        DesignationId: Serenity.LookupEditor;
        DepartmentId: Serenity.IntegerEditor;
        ManagerId: Serenity.LookupEditor;
        ReportToId: Serenity.LookupEditor;
        Dob: Serenity.DateEditor;
        MaritalStatus: Serenity.EnumEditor;
        Gender: Serenity.EnumEditor;
        Qualification: Serenity.ServiceLookupEditor;
        JoiningDate: Serenity.DateEditor;
        TerminationDate: Serenity.DateEditor;
        BloodGroup: Serenity.EnumEditor;
        IsDisabled: Serenity.BooleanEditor;
        Narration: Serenity.StringEditor;
        Departments: Serenity.LookupEditor;
        Address: Serenity.StringEditor;
        PhoneNumber: Serenity.StringEditor;
        MobileNumber: Serenity.StringEditor;
        Email: Serenity.EmailEditor;
        SalaryType: Serenity.EnumEditor;
        DailyWage: Serenity.DecimalEditor;
        GrossSalary: Serenity.DecimalEditor;
        SalaryPackageId: Serenity.ServiceLookupEditor;
        LeavePolicyId: Serenity.ServiceLookupEditor;
        BankName: Serenity.StringEditor;
        BranchName: Serenity.StringEditor;
        BankAccountNumber: Serenity.StringEditor;
        BranchCode: Serenity.StringEditor;
        BankIfsc: Serenity.StringEditor;
        PanNumber: Serenity.StringEditor;
        PfNumber: Serenity.StringEditor;
        EsiNumber: Serenity.StringEditor;
        PassportNo: Serenity.StringEditor;
        PassportExpiryDate: Serenity.DateEditor;
        VisaNumber: Serenity.StringEditor;
        VisaExpiryDate: Serenity.DateEditor;
        LabourCardNumber: Serenity.StringEditor;
        LabourCardExpiryDate: Serenity.DateEditor;
        ExtraDate: Serenity.DateEditor;
        Extra1: Serenity.StringEditor;
        Extra2: Serenity.StringEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class EmployeeMasterForm extends Serenity.PrefixedContext {
        static formKey = 'Master.EmployeeMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EmployeeMasterForm.init)  {
                EmployeeMasterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.ServiceLookupEditor;
                var w2 = s.LookupEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.DateEditor;
                var w5 = s.EnumEditor;
                var w6 = s.BooleanEditor;
                var w7 = s.EmailEditor;
                var w8 = s.DecimalEditor;

                Q.initFormType(EmployeeMasterForm, [
                    'EmployeeCode', w0,
                    'EmployeeName', w0,
                    'EmploymentType', w1,
                    'DesignationId', w2,
                    'DepartmentId', w3,
                    'ManagerId', w2,
                    'ReportToId', w2,
                    'Dob', w4,
                    'MaritalStatus', w5,
                    'Gender', w5,
                    'Qualification', w1,
                    'JoiningDate', w4,
                    'TerminationDate', w4,
                    'BloodGroup', w5,
                    'IsDisabled', w6,
                    'Narration', w0,
                    'Departments', w2,
                    'Address', w0,
                    'PhoneNumber', w0,
                    'MobileNumber', w0,
                    'Email', w7,
                    'SalaryType', w5,
                    'DailyWage', w8,
                    'GrossSalary', w8,
                    'SalaryPackageId', w1,
                    'LeavePolicyId', w1,
                    'BankName', w0,
                    'BranchName', w0,
                    'BankAccountNumber', w0,
                    'BranchCode', w0,
                    'BankIfsc', w0,
                    'PanNumber', w0,
                    'PfNumber', w0,
                    'EsiNumber', w0,
                    'PassportNo', w0,
                    'PassportExpiryDate', w4,
                    'VisaNumber', w0,
                    'VisaExpiryDate', w4,
                    'LabourCardNumber', w0,
                    'LabourCardExpiryDate', w4,
                    'ExtraDate', w4,
                    'Extra1', w0,
                    'Extra2', w0,
                    'CompanyId', w3
                ]);
            }
        }
    }
}
